import { render, staticRenderFns } from "./FormColor.vue?vue&type=template&id=75c8376a&scoped=true&"
import script from "./FormColor.vue?vue&type=script&lang=js&"
export * from "./FormColor.vue?vue&type=script&lang=js&"
import style0 from "./FormColor.vue?vue&type=style&index=0&id=75c8376a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c8376a",
  null
  
)

export default component.exports